export const Config = {
    apiBaseUrl: process.env.API_BASE_URL || "",
    shopifyApiKey: process.env.SHOPIFY_API_KEY || "",
    commitSha: process.env.COMMIT_SHA || "",
};
